const reloadBrowserPage = () => window.location.reload();

export default reloadBrowserPage;
